<script>
	import Router from 'svelte-spa-router'
	import Footer from './components/shared/Footer.svelte'
	import HeaderAdvertiser from "./components/ad-owner/Header.svelte"
	import AdOwnerHome from "./ad-pages/Home.svelte"
	import AdCampaigns from "./ad-pages/Campaigns.svelte"
	import AdOwnerTVSpots from "./ad-pages/TV-Spots.svelte"
	// import AdPastCampaigns from './ad-pages/ViewPastCampaign.svelte'
	import AdCampaignIndividual from './ad-pages/CampaignIndividual.svelte'
	import AdOwnerLogin from './ad-pages/auth/AdOwnerLogin.svelte'
	import AdOwnerSignup from './ad-pages/auth/AdOwnerSignup.svelte'
	import AdUpload from './ad-pages/UploadAd.svelte'
	import TVSpotsBid from './ad-pages/TV-Spots-Bid.svelte'

	import DirectBetween from './shared-pages/DirectBetween.svelte'
	
	import HeaderTvOwner from "./components/tv-owner/Header.svelte"
	import TVHome from './tv-pages/TvHome.svelte'
	import TVViewBids from './tv-pages/ViewBids.svelte'
	import TVProfile from './tv-pages/Profile.svelte'
	import TVOwnerLogin from './tv-pages/auth/TVOwnerLogin.svelte'
	import TVOwnerSignup from './tv-pages/auth/TVOwnerSignup.svelte'
	import SetUpBriteStick from './tv-pages/SetUpBriteStick.svelte'
	import ManageGroups from './tv-pages/ManageGroups.svelte'
	import ManageScreens from './tv-pages/ManageScreens.svelte'
	import ManageSpots from './tv-pages/ManageSpots.svelte'
	import NewAnnouncement from './tv-pages/NewAnnouncement.svelte'
	import ManageIndividualScreen from './tv-pages/ManageIndividualScreen.svelte'
	
	import { onMount } from 'svelte';
	let TVHeader
	
	let vis = {}
	const routes = {
		'/': TVHome,
		// '/': DirectBetween,
		'/advertiser': AdOwnerHome,
		'/advertiser/campaigns': AdCampaigns,
		'/advertiser/tv-spots': AdOwnerTVSpots,
		// '/advertiser/campaigns/past': AdPastCampaigns,
		'/advertiser/campaigns/*': AdCampaignIndividual,
		'/advertiser/auth/login': AdOwnerLogin,
		'/advertiser/upload-ad': AdUpload,
		'/advertiser/auth/sign-up': AdOwnerSignup,
		'/advertiser/place-bid/*': TVSpotsBid,

		'/brite-host': TVHome,
		'/brite-host/tv-home': TVHome,
		'/brite-host/view_bids': TVViewBids,
		'/brite-host/profile' : TVProfile,
		'/brite-host/setup-britestick' : SetUpBriteStick,
		'/brite-host/auth/login': TVOwnerLogin,
		'/brite-host/auth/sign-up': TVOwnerSignup,
		'/brite-host/manage-groups': ManageGroups,
		'/brite-host/:group/manage-screens': ManageScreens,
		'/brite-host/:group/manage-spots': ManageSpots,
		'/brite-host/:group/new-announcement/:spot': NewAnnouncement,
		'/brite-host/:group/manage-screen/:screen': ManageIndividualScreen
 		// '*': NotFound,
	}
	const url = window.location.href

	import tvOwnerPreloader from './tv-pages/preloader'
	import adOwnerPreloader from './ad-pages/preloader'
	let advertiserVis
	let brtieHostVis
	function init(e) {
		advertiserVis = e.detail.location.indexOf("advertiser") !== -1
		brtieHostVis = e.detail.location.indexOf("brite-host") !== -1
		if (advertiserVis) {
			adOwnerPreloader()
		} else if (brtieHostVis) {
			tvOwnerPreloader()
		} 
		// TODO temp and needs removal
		else {
			window.location.href = "#/brite-host"
		}
	}
</script>

<style>
	.body-main {
		min-height: 83%;
		height: fit-content;
		position: relative;
	}

	/* @media  screen and (max-width: 500px) { 
  .body-main { 
    display: none; 
  } 
} */

/* @media screen and (min-width: 501px) {  */
  .not_ready {  
	display:none;  
    
  } 
/* } */

/* @media screen and (max-width: 500px) {

.not_ready{
	font-size: 40px;
	font-weight: bold;
	font-family: Montserrat;

}

} */
.main-container {
	min-height: 100%;
}
.wrapper {
	pointer-events: fill;
}
</style>

<div class="main-container">
	<div class="body-main">
		{#if advertiserVis}
			<HeaderAdvertiser></HeaderAdvertiser>
		{:else if brtieHostVis}
			<div on:mount="{init}"></div>
			<HeaderTvOwner bind:this={TVHeader}></HeaderTvOwner>
		{/if}
		<div on:click={(e) => TVHeader.collapse(e)} class="wrapper" style="">
			<Router {routes} on:routeLoaded={init} />
		</div>
	</div>
	<!-- <div class="not_ready full-screen">This Website Is Not Ready For Mobile Viewing, Please Use a Desktop</div> -->
</div>
<Footer></Footer>
